import React, { useState, useEffect } from 'react';
import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';
import { secondsToTime } from '../../utilities/scoringUtilities';

import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Badge from "react-bootstrap/Badge"
import { ScoringInputType } from '../../models/enums/ScoringInputType';
import Scoring from '../Scoring';

const BreakdownGraph = (props) => {
    const {labels, homeTeamDatapoints, awayTeamDatapoints} = props;

    ChartJS.register(
        RadialLinearScale,
        PointElement,
        LineElement,
        Filler,
        Tooltip,
        Legend
    );

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
            duration: 0
        },
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
        },
    };

    const data = {
        labels,
        datasets: [
            {
                data: homeTeamDatapoints,
                borderWidth: 2,
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
                pointRadius: 8,
            },
            {
                data: awayTeamDatapoints,
                borderWidth: 2,
                backgroundColor: 'rgba(80, 80, 255, 0.5)',
                pointRadius: 8,
            }
        ],
    };

    return <>
        <div style={{whiteSpace: 'nowrap', height: '600px'}}>
            <Radar options={options} data={data}/>
        </div>
    </>

}

export default BreakdownGraph;